import { DirectionalLightShadow } from '../../thirdparty/three/imports';
import { OrthographicCamera3D } from '../cameras/OrthographicCamera3D';
import { Node3D } from '../core/Node3D';
import { LightShadow3D } from './LightShadow3D';

export class DirectionalLightShadow3D extends LightShadow3D
{
    declare _shadow: DirectionalLightShadow;

    camera: OrthographicCamera3D;

    constructor(shadow: DirectionalLightShadow)
    {
        super();
        this._shadow = shadow;

        this.camera = new Node3D().addComponent('OrthographicCamera3D');
        this.camera._camera = shadow.camera;
    }
}
